import { isMockServices } from 'src/utils';
import mock from '../utils/mock';
import { authTokenHttp } from '../utils/authTokenHttp';
import { INCOME_ERROR_MESSAGES } from './errorMessages';
import {
  handleIncomeServiceError,
  validateIncomeResponse,
  validateIncomeSuccess,
} from './errorHandlers';

export interface TriggerIncomeCalculationParams {
  loanId: string;
}

export interface TriggerIncomeCalculationResponse {
  success: boolean;
  message: string;
  transactionId?: string;
  error?: {
    code: string;
    message: string;
  };
}

const triggerIncomeCalculation = async (
  params: TriggerIncomeCalculationParams,
): Promise<TriggerIncomeCalculationResponse> => {
  if (isMockServices()) {
    return await mock({
      success: true,
      message: 'Income calculation triggered successfully',
      transactionId: 'mock-transaction-123',
    });
  }

  try {
    const response = await authTokenHttp<TriggerIncomeCalculationResponse>(
      `/loans/${params.loanId}/income-clarity/trigger`,
      {
        method: 'POST',
      },
    );

    validateIncomeResponse(response.data, INCOME_ERROR_MESSAGES.NO_RESPONSE);

    // At this point, response.data is guaranteed to be non-null due to validateIncomeResponse
    const data = response.data!;
    validateIncomeSuccess(data, INCOME_ERROR_MESSAGES.TRIGGER_FAILED);

    return data;
  } catch (error) {
    return handleIncomeServiceError(error);
  }
};

export default triggerIncomeCalculation;
